const getCalendarPage = (month, year, dayProps, weekStart = 0) => {
  const date = new Date(year, month, 1)
  const startDateOffset = date.getDate() > date.getDay() ? -7 + weekStart : weekStart
  date.setDate(date.getDate() - date.getDay() + startDateOffset)

  const nextMonth = month === 11 ? 0 : month + 1
  const weeks = []
  while (date.getMonth() !== nextMonth || date.getDay() !== weekStart || weeks.length !== 6) {
    if (date.getDay() === weekStart) weeks.unshift({ days: [], id: `${year}${month}${year}${weeks.length}` })

    const updated = Object.assign(
      {
        partOfMonth: date.getMonth() === month,
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
        date: new Date(date)
      },
      dayProps(date)
    )
    weeks[0].days.push(updated)

    date.setDate(date.getDate() + 1)
  }
  weeks.reverse()
  return { month, year, weeks }
}

const getDayPropsHandler = (start, end, selectableCallback, taggedCallback) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return date => {
    const isInRange = date >= start && date <= end

    return {
      isInRange,
      classes: taggedCallback ? taggedCallback(date) : '',
      selectable: isInRange && (!selectableCallback || selectableCallback(date)),
      isToday: date.getTime() === today.getTime()
    }
  }
}

export function getMonths(start, end, selectableCallback = null, taggedCallback = null, weekStart = 0) {
  start.setHours(0, 0, 0, 0)
  end.setHours(0, 0, 0, 0)
  const endDate = new Date(end.getFullYear(), end.getMonth() + 1, 1)
  const months = []
  const date = new Date(start.getFullYear(), start.getMonth(), 1)
  const dayPropsHandler = getDayPropsHandler(start, end, selectableCallback, taggedCallback)
  // eslint-disable-next-line no-unmodified-loop-condition
  while (date < endDate) {
    months.push(getCalendarPage(date.getMonth(), date.getFullYear(), dayPropsHandler, weekStart))
    date.setMonth(date.getMonth() + 1)
  }
  return months
}

export const areDatesEquivalent = (a, b) =>
  a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()
